var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.182,
    height: 11.774,
    viewBox: "0 0 8.182 11.774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(140.182 15.774) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(132 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.988,11.2a.66.66,0,0,0-.933,0l-2.3,2.315V4.66a.66.66,0,1,0-1.32,0v8.856l-2.3-2.315a.66.66,0,0,0-.935.931l3.431,3.448h0a.66.66,0,0,0,.934,0h0l3.431-3.448A.66.66,0,0,0,139.988,11.2Z",
    transform: "translate(-132 -4)",
    fill: "#8b94a5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up-arrow.cbc818e22c369899b0c7836ee363ccb3.svg";
export { ForwardRef as ReactComponent };